import React, { useEffect, useRef, useState } from 'react'
import { NavbarHosming } from '../../components/NavbarHosming'
import { Link, useSearchParams } from 'react-router-dom';
import styles_result from '../../css/hosming/results_styles.css';

import All from '@mui/icons-material/Checklist';
import UsersGroup from '@mui/icons-material/Groups';
import Companys from '@mui/icons-material/Business';
import Publications from '@mui/icons-material/Campaign';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
//import Companys from '@mui/icons-material/Factory';//posible opcion si no funciona el otro
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ApiService, returnFullURL, useProovedorData } from '../../components'

import MenuIcon from '@mui/icons-material/Menu';

const SearchResults = () => {
    const [searchParams] = useSearchParams();
    const parametro = searchParams.get('search');

    const [optionState, setOptionState] = useState(true);
    const [optionSelected, setOptionSelected] = useState("all");
    const [filteredResult, setFilteredResult] = useState({
        people: [],
        companys: [],
        publications: [],
    });
    const [stateResult, setStateResult] = useState(false);

    const { oldResultsSearch, setOldResultsSearch } = useProovedorData() || [];

    const load_search = async () => {
        setStateResult(true);
        var data_search = oldResultsSearch[parametro] ?? null;

        try {
            if (data_search == null) {
                const data = await ApiService.fetchData(`api/user-company?search=${parametro}`);

                setOldResultsSearch(old_results => ({
                    ...old_results,
                    [parametro]: data
                }));

                data_search = data;
            }

            const companys_list = [];
            const people_list = [];
            const publication_list = [];

            (data_search ?? []).forEach((fields) => {
                if (fields.type == "company") companys_list.push(fields);
                if (fields.type == "user") people_list.push(fields);
                if (fields.type == "publication") companys_list.push(fields); //Por ahora no se usara
            });

            setFilteredResult({
                companys: companys_list,
                people: people_list,
                publications: publication_list,
            });
        } catch (error) {
            console.error("Error resultados:", error);
        } finally {
            setStateResult(false);
        }
    };

    useEffect(() => {
        load_search();
    }, [parametro]);

    const htmlResultTypes = (type = "people") => {
        const spanish_type = {
            people: {
                text: "Personas",
                url: "user/posts?authCode="
            },
            companys: {
                text: "Empresas",
                url: "company/products?search="
            },
            publications: {
                text: "Publicaciones",
                url: "url_undefined/"
            },
        };

        if (filteredResult[type].length == 0 || !filteredResult[type]) return (<></>);

        return (
            <div className='views-result'>
                <h3 className='fw-600'>{spanish_type[type].text ?? "Opcion no identificada..."}</h3>
                <div className='view-cards'>
                    {
                        filteredResult[type].map((data) => (
                            <Link to={(spanish_type[type].url ?? "url_undefined/") + data.authCode} className='cards-search'>
                                <div className='cards-search' style={{ border: 'none' }}>
                                    <div className='cards-profile'>
                                        <img src={returnFullURL(data?.perfil ?? null)} alt={'Empresa ' + data.fullName} />
                                    </div>

                                    <div className='cards-info'>
                                        <p className="normal-black fw-600">{data.fullName}</p>
                                        <p className="color-secundary">{data.ubication ?? "Ubicación no asignada"}</p>
                                    </div>
                                </div>


                                <button className='default-buttons button-request button-hover'>
                                    <AddIcon className='request-mobile-icon' />
                                    <span className='request-mobile-text'>Agregar amigo</span>
                                </button>
                            </Link>
                        ))
                    }
                </div>
            </div>
        );
    };


    return (
        <div className='default-styles view-results' key={parametro}>
            <div className='filter-options shadow-lvl6' style={{
                gap: (optionState ? '0px' : '15px')
            }}>
                <div className='head-filter-result'>
                    <IconButton onClick={() => setOptionState((valor) => !valor)}>
                        <MenuIcon className='icons-result color-secundary' />
                    </IconButton>

                    <h2 className={'font-h2 font-h2-hidden color-secundary'}>
                        Filtros
                    </h2>
                </div>

                <ul className={'list-option' + (optionState ? ' hidden-list' : '')}>
                    <li onClick={() => setOptionSelected("all")} className={optionSelected == "all" ? "option-selected" : ""}>
                        <IconButton>
                            <All className='icons-result color-secundary' />
                        </IconButton>
                        <span className={'text-icons color-secundary'}>Todos</span>
                    </li>

                    <li onClick={() => setOptionSelected("people")} className={optionSelected == "people" ? "option-selected" : ""}>
                        <IconButton>
                            <UsersGroup className='icons-result color-secundary' />
                        </IconButton>
                        <span className={'text-icons color-secundary'}>Personas</span>
                    </li>

                    <li onClick={() => setOptionSelected("companys")} className={optionSelected == "companys" ? "option-selected" : ""}>
                        <IconButton>
                            <Companys className='icons-result color-secundary' />
                        </IconButton>
                        <span className={'text-icons color-secundary'}>Empresas</span>
                    </li>

                    <li onClick={() => setOptionSelected("publications")} className={optionSelected == "publications" ? "option-selected" : ""}>
                        <IconButton>
                            <Publications className='icons-result color-secundary' />
                        </IconButton>
                        <span className={'text-icons color-secundary'}>Publicaciones</span>
                    </li>
                </ul>
            </div>

            <div className='list-results'>
                {
                    stateResult == false && filteredResult.companys.length == 0 && filteredResult.people.length == 0 && filteredResult.publications.length == 0 && (
                        <div className='views-result'>
                            <div className='view-cards'>
                                Sin Resultados...
                            </div>
                        </div >
                    )
                }

                {
                    stateResult == true && (
                        <div className='views-result'>
                            <div className='view-cards'>
                                Cargando Resultados...
                            </div>
                        </div >
                    )
                }

                {
                    stateResult == false && (optionSelected == "all" || optionSelected == "people") && (
                        htmlResultTypes("people")
                    )
                }

                {
                    stateResult == false && (optionSelected == "all" || optionSelected == "companys") && (
                        htmlResultTypes("companys")
                    )
                }

                {
                    stateResult == false && (optionSelected == "all" || optionSelected == "publications") && (
                        htmlResultTypes("publications")
                    )
                }
                {/* <img src='https://i.pinimg.com/236x/a7/de/c4/a7dec46aca07b2e12e2e361cfa9312ec.jpg' />
                    <img src='https://i.pinimg.com/236x/50/79/7a/50797aea10642b728588d871862e7690.jpg' />
                    <img src='https://tresubresdobles.com/wp-content/uploads/2021/04/skft-23aff38e10ee3c4e430a1f3450c4a01d.jpeg' /> */}
            </div>
        </div>
    )
}

export default SearchResults